export default __webpack_public_path__ + "media/images/icon_tel_mobil-8a40ac41e3875037fb9a74f849d8ad5c.png";